export default __webpack_public_path__ + "static/media/25.1e77bedf.png";